import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const TextWrapper = styled.div`
  font-weight: ${({ strong }) => (strong ? 'bold' : undefined)};
  font-size: ${({ textSize }) => (textSize ? `${textSize}px` : '16px')};
  color: ${({ textColor }) => textColor};
`;

const Text = ({
  children,
  block,
  paragraph,
  strong,
  textSize,
  textColor,
  ...props
}) => {
  const Tag = block ? 'div' : paragraph ? 'p' : 'span';

  return (
    <TextWrapper
      as={Tag}
      strong={strong}
      textSize={textSize}
      textColor={textColor}
      {...props}
    >
      {children}
    </TextWrapper>
  );
};

Text.propTypes = {
  block: PropTypes.bool,
  paragraph: PropTypes.bool,
  strong: PropTypes.bool,
  textSize: PropTypes.number,
  textColor: PropTypes.string,
};

export default Text;
